module.exports = __webpack_public_path__ + "static/media/basketball-2.bb9c2823.svg";